import type { FC } from 'react';
import { Loader } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const FormIncompleteBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-yellow-500 font-semibold text-neutral-50">
      <Loader aria-hidden />
      {t('component:badge.formIncomplete')}
    </Badge>
  );
};
